export class CartError extends Error {
  internalErrorMessage = null

  constructor(internalErrorMessage, message) {
    super(message || window.theme.strings.cart.errors.general)

    this.name = 'CartError'
    this.internalErrorMessage = internalErrorMessage
  }
}

export class CartItemError extends CartError {
  lineItem = null

  constructor(internalErrorMessage, lineItem, message) {
    if (!lineItem) {
      throw new Error('lineItem is required in cart item error data')
    }

    super(internalErrorMessage, message)

    this.name = 'CartItemError'
    this.lineItem = lineItem
  }
}

export class AddToCartError extends CartError {
  constructor(internalErrorMessage, message) {
    message = message || window.theme.strings.cart.errors.add_to_cart_error
    super(internalErrorMessage, message)

    this.name = 'AddToCartError'
  }
}

export class UpdateCartError extends CartItemError {
  constructor(internalErrorMessage, lineItem, message) {
    message = message || window.theme.strings.cart.errors.update_cart_error
    super(internalErrorMessage, lineItem, message)

    this.name = 'UpdateCartError'
  }
}

export class RemoveFromCartError extends CartItemError {
  constructor(internalErrorMessage, lineItem, message) {
    message = message || window.theme.strings.cart.errors.remove_error
    super(internalErrorMessage, lineItem, message)

    this.name = 'RemoveFromCartError'
  }
}

export class ProductNotFoundCartError extends AddToCartError {
  constructor(internalErrorMessage, message) {
    message = message || window.theme.strings.cart.errors.product_not_found
    super(internalErrorMessage, message)

    this.name = 'ProductNotFoundCartError'
  }
}

export class NotEnoughStockCartError extends AddToCartError {
  constructor(internalErrorMessage, message) {
    message = message || window.theme.strings.cart.errors.not_enough_stock
    super(internalErrorMessage, message)

    this.name = 'NotEnoughStockCartError'
  }
}

export class ProductNotInCartError extends UpdateCartError {
  constructor(internalErrorMessage, lineItem, message) {
    message = message || window.theme.strings.cart.errors.product_not_in_cart
    super(internalErrorMessage, lineItem, message)

    this.name = 'ProductNotInCartError'
  }
}

export class NotEnoughStockCartItemError extends UpdateCartError {
  constructor(internalErrorMessage, lineItem, message) {
    message = message || window.theme.strings.cart.errors.not_enough_stock_item
    super(internalErrorMessage, lineItem, message)

    this.name = 'NotEnoughStockCartItemError'
  }
}

export class InvalidDiscountCodeError extends CartError {
  constructor(internalErrorMessage, message) {
    message = message || window.theme.strings.cart.errors.invalid_discount_code
    super(internalErrorMessage, message)

    this.name = 'InvalidDiscountCodeError'
  }
}

export class DiscountCodeFormError extends CartError {
  constructor(internalErrorMessage, message) {
    message = message || window.theme.strings.cart.errors.discount_code_error
    super(internalErrorMessage, message)

    this.name = 'DiscountCodeError'
  }
}
